import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import { fetchJson } from '../../../../helpers/fetch.js';
import { useSetWidgetAttribute } from '../../hooks/useSetWidgetAttribute.js';
import CollapsibleSection from '../../../common/CollapsibleSection.jsx';
import SelectSetting from '../../settings_sidebar/common/SelectSetting.jsx';
import SettingsSection from '../../settings_sidebar/common/SettingsSection.jsx';
import InputSkeleton from '../../../../skeleton_loaders/common/InputSkeleton.jsx';
import ToggleSetting from '../../settings_sidebar/ag_chart/components/ToggleSetting.jsx';
import AutoHeightSettings from '../../settings_sidebar/AutoHeightSettings.jsx';
import WidgetTitleSettings from '../../settings_sidebar/WidgetTitleSettings.jsx';

import {
  work_queue_list_json_path
} from '~/routes';

function MyWorkQueuesWidgetSettings({ widgetId }) {
  const setAttribute = useSetWidgetAttribute(widgetId);
  const settings = useSelector(state => state.dashboard.widgets[widgetId]?.settings ?? {});
  
  const {data: workQueues = {rows: []}, isLoading} = useQuery({
    queryKey: ['myWorkQueuesList'],
    queryFn: () => fetchJson(work_queue_list_json_path({only_own: true}), {method: 'POST'}),
    enabled: true
  });

  const widgetSettingProps = {
    prefix: '',
    selectedObject: settings,
    widgetId,
    setAttribute: (path, val) => setAttribute(`settings.${path}`, val)
  };

  const workQueueOptions = useMemo(() => {
    return workQueues.rows.map(q => ({value: q.id, label: q.name}));
  }, [workQueues]);

  return (
    <>
      <CollapsibleSection title={I18n.t('content_settings')}>
        <SettingsSection>
          <WidgetTitleSettings widgetId={widgetId} />
          <ToggleSetting
            {...widgetSettingProps}
            attr='condensedMode'
            label={I18n.t('condensed_mode')}
            hideDescription={true}
          />
          <SelectSetting
            {...widgetSettingProps}
            defaultValue='all_queues'
            attr='listMode'
            label={I18n.t('list_mode')}
            hideDescription={true}
            options={[
              {value: 'all_queues', label: I18n.t('all_queues')},
              {value: 'chosen_queues', label: I18n.t('chosen_queues')}
            ]}
            isClearable={false}
          />

          {settings?.listMode === 'chosen_queues' && 
            <>
              {isLoading
                ? <InputSkeleton />
                : <SelectSetting
                    {...widgetSettingProps}
                    attr='workQueueIds'
                    label={I18n.t('work_queues')}
                    hideDescription={true}
                    options={workQueueOptions}
                    isMulti={true}
                  />
                }
            </>
          }

          <AutoHeightSettings widgetId={widgetId} />
        </SettingsSection>
      </CollapsibleSection>
      
    </>
  )
}

export default MyWorkQueuesWidgetSettings;